class FlipbookProductPopup extends HTMLElement {
    constructor() {
        super();
        this.modal = null;
        this.sku = "";
        this.activeImage = "";
        this.image = [];
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.modal = this.querySelector('.modal');
        this.bindEvents();
    }

    bindEvents() {
        window.onclick = (event) => {
            if (event.target == this.modal) {
                this.close();
            }
        };
        this.querySelector(".close")?.addEventListener('click', () => this.close());
    }

    open(status) {
        this.modal?.classList.add('open');
        this.setStatus(status);
        document.querySelector('body')?.classList.add('body-noscroll-class');
    }

    setStatus(status) {
        let statusDiv = this.modal?.querySelector('.modal-status');
        if (statusDiv) {
            statusDiv.innerHTML = status;
        }
    }

    showHideProductInfo() {
        let productWrap = this.querySelector('.product-wrapper');
        if (productWrap) {
            if (this.productData !== null) {
                productWrap.classList.add('hydrated');
            } else {
                productWrap.classList.remove('hydrated');
            }
        }
    }

    async setData(sku, productData) {
        let result = true;
        this.sku = sku;
        this.productData = productData;
        result = result && this.refreshImages();
        result = result && (await this.refreshProductData());
        if (result) {
            this.showHideProductInfo();
        }
        return result;
    }

    async refreshProductData() {
        let productContentWrap = this.querySelector('product-content-wrap');
        if (productContentWrap) {
            productContentWrap.innerHTML = this.productData?.tableHtml ?? '';
        }

        // Clear accessories
        const accessoriesWrap = this.querySelector('.accessories-wrapper');
        console.log("accessoriesWrap exists:", !!accessoriesWrap);
        accessoriesWrap.innerHTML = '';

        // Get accessories metafield
        const accessories = this.productData?.metafields?.custom?.productaccessories?.value;
        console.log("Accessory metafield:", accessories);

        if (Array.isArray(accessories) && accessories.length > 0) {
            let shownAccessories = 0;

            for (const accessory of accessories) {
                if (shownAccessories >= 4) break;

                const sku = accessory.SKU;
                console.log(`Fetching accessory data for SKU: ${sku}`);

                try {
                    const accessoryData = await FlipbookProductPopupHelper.getProductData(sku);
                    console.log(`Accessory data loaded for ${sku}:`, accessoryData);

                    const isInStock = accessoryData?.product?.variants?.some(v => v.available);
                    if (!isInStock) {
                        console.log(`Accessory ${sku} is out of stock. Skipping.`);
                        continue;
                    }

                    if (accessoryData?.tableHtml) {
                        const accessoryWrap = document.createElement('div');
                        accessoryWrap.classList.add('accessory-wrap');

                        const contentWrap = document.createElement('product-content-wrap');
                        contentWrap.innerHTML = accessoryData.tableHtml;
                        accessoryWrap.appendChild(contentWrap);

                        accessoriesWrap.appendChild(accessoryWrap);
                        shownAccessories++;
                    }
                } catch (err) {
                    console.error(`Failed to load accessory product ${sku}`, err);
                }
            }
        } else {
            console.log("No accessories found or metafield is invalid.");
        }

        let productWrap = this.querySelector('.product-wrapper');
        setTimeout(() => {
            productWrap?.classList.add('hydrated');
            if (window.spark) {
                SmiffysCartQuantityLoader.getCartAndUpdateUi();
            }
        }, 300);

        return false;
    }

    refreshImages() {
        if (this.productData == null) {
            this.activeImage = "";
            this.image = [];
            return false;
        }

        this.image = this.productData?.product.images;
        this.activeImage = this.image[0];
        let mainImageEle = this.querySelector('.active-image img');
        if (mainImageEle) {
            mainImageEle.src = this.image[0];
        }

        let images = this.querySelector('.image-list');
        images.innerHTML = '';
        setTimeout(() => {
            this.image.forEach(element => {
                const newDiv = document.createElement("div");
                const newImage = document.createElement("img");
                newImage.classList.add('product-image-selector');
                if (this.image[0] === element) {
                    newImage.classList.add('selected-image');
                }
                newImage.src = element;
                newImage.setAttribute('data-image-src', element);
                newImage.addEventListener('click', () => {
                    let allSmallImages = this.querySelectorAll('.product-image-selector');
                    for (const allSmallImage of allSmallImages) {
                        allSmallImage.classList.remove('selected-image');
                    }
                    newImage.classList.add('selected-image');
                    mainImageEle.src = element;
                });
                newDiv.appendChild(newImage);
                images.appendChild(newDiv);
            });
        }, 300);
        return true;
    }

    close() {
        this.modal?.classList.remove('open');
        let productWrap = this.querySelector('.product-wrapper');
        productWrap.classList.remove('hydrated');
        document.querySelector('body')?.classList.remove('body-noscroll-class');
    }
}

class FlipbookProductPopupHelper {
    static dateToString(jsonDate) {
        try {
            var dp = JSON.parse(`\"${jsonDate}\"`);
            var d = new Date(dp);
            return d.toLocaleDateString('en-GB');
        } catch (e) {
            console.log(e);
        }
        return "";
    }

    static async getProductData(handle) {
        let url = `/products/${handle}?view=popup`;
        return await fetch(url)
            .then(response => response.text())
            .then(result => JSON.parse(result))
            .catch(error => {
                console.log('Fetch error:', error);
                return null;
            });
    }

    static async processMessageEvent(event) {
        if (event.data === 'closecart') {
            return;
        }

        console.log("Received message event for SKU:", event.data);

        let popup = document.querySelector('flipbook-product-popup');
        popup.open("Getting data...");

        let sku = event.data;
        let pd = await FlipbookProductPopupHelper.getProductData(sku);
        console.log("Full productData object:", pd);

        if (!pd) {
            popup.setStatus('This item is not currently available in your territory');
            return;
        }

        popup.setStatus('');
        let result = await popup.setData(sku, pd);
        if (result) {
            popup.showHideProductInfo();
        }
    }
}

(() => {
    customElements.define("flipbook-product-popup", FlipbookProductPopup);
})();

setTimeout(() => {
    window.addEventListener('message', receiveMessage, false);
    async function receiveMessage(event) {
        if (event.origin === 'https://flipbook.smiffys.com') {
            await FlipbookProductPopupHelper.processMessageEvent(event);
        }
    }
}, 0);

export {};
